import { Route } from '@angular/router';
import { NotFoundComponent } from '@src/app/main-layout/errors/not-found/not-found.component';
import { HomeComponent } from '@src/app/main-layout/dashboard/home.component';
import { LoginComponent } from '@src/app/main-layout/login/login.component';
import { RegisterComponent } from '@src/app/main-layout/register/register.component';
import { AuthGuard } from '@src/app/_guards/auth.guard';
import { USER_ROUTES } from '@src/app/features/users/users.routes';
import { MAILER_ROUTES } from '@src/app/mailer/mailer.routes';
import { HOTLINE_ROUTES } from '@src/app/features/hotline/hotline.routes';

export const ROUTES: Route[] = [
    {
        path: '',
        component: HomeComponent,
        data: { title: 'Hlavní nástěnka' },
        canActivate: [AuthGuard],
    },
    ...USER_ROUTES,
    ...HOTLINE_ROUTES,
    ...MAILER_ROUTES,
    {
        path: 'login',
        component: LoginComponent,
        data: { title: 'Online Office Solutions', value: 'login' },
    },
    {
        path: 'register',
        component: RegisterComponent,
        data: { value: 'register' },
    },

    { path: '**', component: NotFoundComponent, data: { value: 'notfound' } },
];
